/* eslint-disable no-magic-numbers */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-useless-return */
/* eslint-disable max-depth */
/* eslint-disable prefer-template */
/* eslint-disable no-return-assign */
/* eslint-disable prefer-const */
/* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/prefer-for-of */
/* eslint-disable max-lines-per-function */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-unused-expressions */
/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/prefer-optional-chain */
/* eslint-disable no-var */
/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable max-params */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */

import { ChangeDetectorRef, Component, DestroyRef, ElementRef, OnInit, inject, input, signal, viewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IAgentChipList } from '../../interfaces/IAgentChatInterface';
import { ChatContent, ChatMessage } from '../../models/chat.model';
import { EvaDciRequestPayload, EvaDciResponse, EvaMessageInput, EvaRequestPayload, EvaResponse } from '../../models/eva-request.model';
import { AIAgentService } from '../../services/ai-agent.service';
// import { SearchData } from './../../../connectivity/_models/Connectivity';
// import { SearchResultModal } from '../../../global-search-filters/contracts/modal';
import { Router } from '@angular/router';
import { LocalCacheService } from '../../../../../../../../../app/core/local-cache/local-cache.service';
import { SearchInputData } from '../../constant/search-input.config';
import { getLegionellaEvaDciContext, getLegionellaResponseContent, getLegionellaSessionId } from '../../utils/legionella.util';
import { ChatHistoryListComponent } from '../chat-history-list/chat-history-list.component';

/**
 * EVA (Ecolab Virtual Assistant) AI Agent Component
 * 
 * Main chat interface component for interacting with EVA, the AI-powered virtual assistant.
 * Provides features including:
 * - Real-time text-based chat with EVA API integration
 * - Voice input support using Web Speech API
 * - Message streaming for bot responses
 * - Chat history management
 * - Context-aware conversations based on selected sites/context points
 * - Suggestion chips for common queries
 * - Feedback collection for bot responses
 * 
 * @example
 * <nalco-eva-agent></nalco-eva-agent>
 */
@Component({
  selector: 'nalco-eva-agent',
  templateUrl: './ai-agent-bot.component.html',
  styleUrl: './ai-agent-bot.component.scss',
  standalone: false
})
export class EVAAIAgentComponent implements OnInit {
  private readonly defaultSuggestions: string[] = [
    'Take me to all priorities',
    'Show me all priorities',
    'Let’s dive into the first Top Priority'
  ];

  private readonly aiAgentService = inject(AIAgentService);
  readonly translate = inject(TranslateService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly localCacheService = inject(LocalCacheService);
  private readonly destroyRef = inject(DestroyRef);
  private readonly router = inject(Router);

  /** Icon image source URL for the AI agent trigger button */
  readonly agentIconSrc = input('../../../../../assets/Icon-AI-Agent.svg');

  /** Controls visibility of the agent trigger icon button; hidden by default */
  readonly showAgentIcon = input(false);

  /** Reference to the chat container DOM element for scroll management */
  readonly chatContainer = viewChild<ElementRef>('chatContainer');

  /** Reference to the chat history list component */
  readonly chatHistoryList = viewChild<ChatHistoryListComponent>('chatHistoryList');

  /** Reference to image file input element */
  readonly imageInput = viewChild<ElementRef<HTMLInputElement>>('imageInput');

  /** Array of chat messages (user and bot) in the current conversation */
  readonly messages = signal<ChatMessage[]>([]);

  sampleMessages: ChatMessage[] = [
    {
      id: 'sample-eva-message-1',
      type: 'bot',
      timestamp: new Date(),
      content: {
        type: 'text',
        data: `<strong>Let's take a look at this critical priority</strong><br/>Here are some recommended actions you can take`
      }
    },
    {
      id: 'sample-eva-message-2',
      type: 'bot',
      timestamp: new Date(),
      content: {
        type: 'text',
        data: `I found repeated cooling tower performance variance over the last 30 days. The largest deviation appears during peak load windows.`
      }
    }
  ];
  sampleEvaSuggestions: string[] = [
    'Take me to all priorities',
    'Show me all priorities',
    'Let’s dive into the first Top Priority'
  ];
  /** Current message being typed by the user */
  currentMessage: string = '';

  /** Indicates if a bot response is currently being loaded */
  isLoading: boolean = false;

  /** Indicates if a request is currently being sent to the API */
  sendingRequest: boolean = false;

  /** Connection status with the EVA backend service */
  isConnected: boolean = true;

  /** ID of the selected context point (site/location) for contextual conversations */
  contextPointId: number | null = null;

  /** Subject for managing component lifecycle and subscription cleanup */
  private destroy$ = new Subject<void>();

  /** Web Speech API recognition instance for voice input */
  private recognition: any;

  /** Indicates if voice recording is currently active */
  isRecording: boolean = false;

  /** Indicates if voice recognition is supported in the current browser */
  voiceSupported: boolean = false;

  /** Current microphone permission state: 'granted', 'denied', or 'prompt' */
  microphonePermission: string = 'prompt';

  /** Dynamic placeholder message for the input textarea */
  placeHolderMessage!: string;

  /** Timeout reference for voice recording management */
  private recordingTimeout: any;

  /** Minimum height for the auto-resizing textarea in pixels */
  private minTextareaHeight = 40;

  /** Maximum height for the auto-resizing textarea in pixels */
  private maxTextareaHeight = 96;

  /** Flag indicating if input validation error should be shown */
  noInput: boolean = false;

  /** Currently selected feedback data for a message */
  feedBackSelected: { messageId: string, didUserLike: boolean | null, feedBack: string } = { messageId: '', didUserLike: null, feedBack: '' };

  /** Message displayed while EVA is processing a request */
  agentProcessingMessage = "Let me check that for you...";

  /** Configuration data for search input component */
  searchInputData: any;

  /** ID of the message currently being edited, null if no edit in progress */
  editMessageId: string | null = null;

  /** Content of the message being edited */
  editingMessage: string = '';

  /** Controls visibility of the AI agent flyout panel */
  showAIAgent = false;

  /** Details of the currently selected search result (site/location) */
  selectedSearchDetails: any = { name: null };

  /** Current chat session ID for conversation continuity */
  chatID: string | null = null;

  /** Cache for context point details to avoid redundant API calls */
  private contextPointCache: { [contextPointId: string]: { contextPointId: number, siteName: string } } = {};

  /** Indicates if a chat history is currently being loaded */
  isLoadingChat!: boolean;

  /** Controls whether bot message streaming is enabled */
  enableChatStreaming = false;

  /** Search result modal data */
  searchResultModal: any;

  /** Array of suggestion chips to display for user quick actions */
  suggestions: string[] = [];

  /** Unique identifier for the welcome message to control suggestion display */
  private welcomeMessageId: string = 'welcome-message-id';
  currentPlaceholder = 'How can I help you?';

  constructor() {
    // Register cleanup on destroy
    this.destroyRef.onDestroy(() => {
      this.destroy$.next();
      this.destroy$.complete();

      // Clean up speech recognition
      if (this.recognition && this.isRecording) {
        this.isRecording = false;
        this.recognition.stop();
      }

      // Clear any pending timeouts
      if (this.recordingTimeout) {
        clearTimeout(this.recordingTimeout);
      }

      // Clear context point cache on component destroy
      this.clearContextPointCache();
    });
  }

  /**
   * Component initialization lifecycle hook
   * Sets up initial state, voice recognition, and loads the welcome message
   */
  ngOnInit() {
    this.placeHolderMessage = 'Ask me anything..!';
    this.chatID = null;
    //   this.chipList = [
    //   { name: 'Water Quality overview', value: 'Give details about water quality?', iconUrl: '' },
    // ]
    this.searchInputData = JSON.parse(JSON.stringify(SearchInputData))
    this.setupVoiceRecognition();
    this.checkMicrophonePermission();
    this.initializeChat();
    this.contextPointId = this.aiAgentService.getDefaultCorporateId() ?? null;

    // Subscribe to EVA state changes to handle external prompts
    this.aiAgentService.getEvaState$()
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        this.suggestions = state.suggestions && state.suggestions.length
          ? [...state.suggestions]
          : [...this.defaultSuggestions];

        if (state.prompt && state.prompt.trim()) {
          this.currentMessage = state.prompt;
          this.sendMessage();
        }
        if (state.show) {
          this.showAIAgent = true;
        } else if (state.show === false) {
          this.showAIAgent = false;
        }
      });
  }

  /**
   * Initialize chat with welcome message and suggestion chips
   * Generates personalized greeting based on time of day and user's name
   * @private
   */
  private initializeChat() {
    let name = this.localCacheService.fetchData('User_FirstName', 'local');
    let greeting = this.getTimeBasedGreeting();

    // Add welcome message
    this.messages.set([]);
    this.chatID = null;
    const welcomeMessage: ChatMessage = {
      id: this.welcomeMessageId,
      type: 'bot',
      timestamp: new Date(),
      content: {
        type: 'text',
        data: `<strong>${greeting},${name ? ' ' + name : ''}.</strong>! ${this.translate.instant('AI_AGENT.AGENT_WELCOME_MESSAGE')} <br/> <span style="color: #313233">${this.translate.instant('AI_AGENT.HELP_QUESTION')}</span>`
      }
    };
    this.messages.update(msgs => [...msgs, welcomeMessage]);
    this.suggestions = [...this.defaultSuggestions];
    this.scrollToBottom();
  }

  /**
   * Send user message to EVA API and process response
   * Handles message validation, API communication, and error scenarios
   * 
   * @param editMessageId - Optional ID for editing an existing message
   */
  sendMessage(editMessageId?: string) {
    this.scrollToBottom();
    this.noInput = !this.currentMessage?.trim().length;
    this.enableChatStreaming = true;
    if (!this.currentMessage?.trim() || this.isLoading) {
      this.currentMessage = '';
      return;
    }

    this.sendingRequest = true;
    const userMessage: ChatMessage = {
      id: editMessageId ? editMessageId : this.generateId(),
      type: 'user',
      timestamp: new Date(),
      content: {
        type: 'text',
        data: this.currentMessage
      }
    };

    this.messages.update(msgs => [...msgs, userMessage]);
    this.scrollToBottom();
    this.currentMessage = '';
    this.isLoading = true;

    // Reset textarea height after clearing message
    setTimeout(() => {
      const textarea = document.getElementById('ask-label') as HTMLTextAreaElement;
      if (textarea) {
        textarea.style.height = this.minTextareaHeight + 'px';
      }
    }, 0);

    // DCI (Legionella Dashboard) specific flow: if the current route is for Legionella Test Results, 
    // use a different API endpoint and payload structure. 
    // P.S. Will be removed once API for DCI (Legionella Dashboard) is unified in BED.
    if (this.isLegionellaTestResultsRoute()) {
      this.getLegionellaSpecificEvaResponse();
      return;
    }

    const payload = this.buildEvaRequestPayload();

    // Send message to EVA response API
    this.aiAgentService.getEVAResponse(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: EvaResponse | null) => {
        // Use response id as chat id for latest response tracking
        this.chatID = response?.id ?? this.chatID;

        const botMessage: ChatMessage = {
          id: this.chatID || this.generateId(),
          type: 'bot',
          timestamp: new Date(),
          content: this.parseResponse(response)
        };
        this.messages.update(msgs => [...msgs, botMessage]);
        this.isLoading = false;
        this.sendingRequest = false;
        this.scrollToBottom();
      },
        (_error: any) => {
          const errorMessage: ChatMessage = {
            id: this.generateId(),
            type: 'bot',
            timestamp: new Date(),
            content: {
              type: 'text',
              data: 'Sorry, I encountered an error while processing your request. Please try again.'
            }
          };
          this.messages.update(msgs => [...msgs, errorMessage]);
          this.isLoading = false;
          this.sendingRequest = false;
          this.scrollToBottom();
        }

      );
  }

  /**
   * Handle keyboard events in the textarea
   * Manages Enter key (send message), Escape key (cancel edit), and auto-resize
   * 
   * @param event - Keyboard event from the textarea
   */
  onKeyPress(event: any) {
    if (this.isRecording) {
      this.recognition.stop();
    }

    // Handle edit mode key presses
    if (this.editMessageId) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        // this.currentMessage = event?.target?.value;
        this.saveEditedMessage();
        return;
      }
      if (event.key === 'Escape') {
        event.preventDefault();
        this.cancelEdit();
        return;
      }
    } else {
      // Normal message input mode
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        this.sendMessage();
      }
    }

    // Auto-adjust textarea height after key press
    setTimeout(() => {
      const textarea = event.target as HTMLTextAreaElement;
      this.adjustTextareaHeight(textarea);
    }, 0);
  }

  /**
   * Handle textarea input for auto-resize and error state
   */
  onTextareaInput(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    this.adjustTextareaHeight(textarea);

    // Clear error state when user starts typing
    if (this.noInput) {
      this.noInput = false;
    }
  }

  /**
   * Auto-adjust textarea height based on content
   */
  private adjustTextareaHeight(textarea: HTMLTextAreaElement): void {
    if (!textarea) return;

    // Reset height to auto to calculate scroll height
    textarea.style.height = 'auto';

    const scrollHeight = textarea.scrollHeight;
    const newHeight = Math.min(Math.max(scrollHeight, this.minTextareaHeight), this.maxTextareaHeight);

    textarea.style.height = newHeight + 'px';

    // Show scrollbar if content exceeds max height
    if (scrollHeight > this.maxTextareaHeight) {
      textarea.style.overflowY = 'auto';
    } else {
      textarea.style.overflowY = 'hidden';
    }
  }

  /**
   * Build EVA API request payload from current message history
   * Converts chat messages to the format expected by the EVA backend
   * 
   * @returns Formatted request payload with message history and context
   * @private
   */
  private buildEvaRequestPayload(): EvaRequestPayload {
    const input: EvaMessageInput[] = [];

    for (const message of this.messages()) {
      if (message?.content?.type !== 'text') {
        continue;
      }

      const content = this.toPlainText(message.content?.data);
      if (!content.length) {
        continue;
      }

      const role: EvaMessageInput['role'] = message.type === 'user' ? 'user' : 'assistant';
      input.push({ role, content });
    }

    return {
      input,
      custom_inputs: {
        plant: this.selectedSearchDetails?.Site || undefined,
        line: undefined
      }
    };
  }

  /**
   * Convert HTML or formatted text to plain text
   * Removes HTML tags and normalizes whitespace
   * 
   * @param value - Input value to convert
   * @returns Plain text string
   * @private
   */
  private toPlainText(value: any): string {
    if (typeof value !== 'string') {
      return String(value ?? '').trim();
    }

    return value.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  /**
   * Parse EVA API response into ChatContent format
   * Handles various response structures and extracts displayable content
   * 
   * @param response - Raw response from EVA API
   * @returns Formatted chat content ready for display
   * @private
   */
  private parseResponse(response: EvaResponse | any): ChatContent {
    // Handle different response types from backend
    try {
      if (response?.output && Array.isArray(response.output)) {
        const assistantMessages = response.output
          .filter((item: any) => item?.type === 'message' && item?.role === 'assistant');

        const latestAssistantMessage = assistantMessages.length
          ? assistantMessages[assistantMessages.length - 1]
          : response.output[response.output.length - 1];

        const text = (latestAssistantMessage?.content || [])
          .map((content: any) => content?.text)
          .filter((contentText: string) => !!contentText)
          .join('\n')
          .trim();

        return {
          type: 'text',
          data: text || 'Sorry, I could not parse the response. Please try again.'
        };
      }

      if (typeof response.Response === 'string') {
        return { type: 'text', data: response.Response };
      }

      if (response.type) {
        return response as ChatContent;
      }

      // Auto-detect response type
      if (Array.isArray(response)) {
        return {
          type: 'list',
          data: { type: 'unordered', items: response },
          metadata: { title: 'Results' }
        };
      }

      if (typeof response === 'object') {
        // Check if it's a table structure
        if (response.headers && response.rows) {
          return {
            type: 'table',
            data: response,
            metadata: { title: response.title || 'Data Table' }
          };
        }

        // Check if it's code
        if (response.code && response.language) {
          return {
            type: 'code',
            data: response.code,
            metadata: { language: response.language }
          };
        }

        // Default to text representation
        response.choices = response.choices[0].message.content || ""
        return {
          type: 'text',
          data: JSON.stringify(response, null, 2)
        };
      }

      return { type: 'text', data: String(response) };

    } catch (error) {
      return {
        type: 'text',
        data: 'Error parsing response from server.'
      };
    }
  }

  /**
   * Generate a unique message ID
   * @returns Random alphanumeric string
   * @private
   */
  private generateId(): string {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  }

  /**
   * Get time-based greeting based on current hour
   */
  private getTimeBasedGreeting(): string {
    const currentHour = new Date().getHours();

    if (currentHour >= 5 && currentHour < 12) {
      return this.translate.instant('AI_AGENT.GOOD_MORNING');
    } else if (currentHour >= 12 && currentHour < 17) {
      return this.translate.instant('AI_AGENT.GOOD_AFTERNOON');
    } else if (currentHour >= 17 && currentHour < 21) {
      return this.translate.instant('AI_AGENT.GOOD_EVENING');
    } else {
      return this.translate.instant('AI_AGENT.HELLO');
    }
  }

  private scrollToBottom(): void {
    setTimeout(() => {
      try {
        const container = this.chatContainer();
        const chatContainerEl = container?.nativeElement;
        if (chatContainerEl) {
          // Try to scroll the last message into view
          const messages = chatContainerEl.querySelectorAll('.message-wrapper');
          if (messages && messages.length > 0) {
            const lastMessage = messages[messages.length - 1];
            lastMessage.scrollIntoView({ behavior: 'smooth', block: 'end' });
          } else {
            // Fallback to scrollTop method
            chatContainerEl.scrollTop = chatContainerEl.scrollHeight;
          }
        }
      } catch (err) {
        console.error('Scroll error:', err);
      }
    }, 200);
  }

  // Will be removed once API for DCI (Legionella Dashboard) is unified in BED.
  private getLegionellaSpecificEvaResponse(): void {
    const latestUserMessage = [...this.messages()]
      .reverse()
      .find(message => message.type === 'user' && message.content?.type === 'text');

    const payload: EvaDciRequestPayload = {
      Message: this.toPlainText(latestUserMessage?.content?.data || ''),
      SessionId: this.chatID
    };
    const queryParams = getLegionellaEvaDciContext();

    this.aiAgentService.getLegionellaSpecificEvaResponse(payload, queryParams)
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: EvaDciResponse | null) => {
        this.chatID = getLegionellaSessionId(response) ?? this.chatID;

        const botMessage: ChatMessage = {
          id: response?.MessageId || this.generateId(),
          type: 'bot',
          timestamp: new Date(),
          content: getLegionellaResponseContent(response)
        };

        this.messages.update(msgs => [...msgs, botMessage]);
        this.isLoading = false;
        this.sendingRequest = false;
        this.scrollToBottom();
      },
        (_error: any) => {
          const errorMessage: ChatMessage = {
            id: this.generateId(),
            type: 'bot',
            timestamp: new Date(),
            content: {
              type: 'text',
              data: 'Sorry, I encountered an error while processing your request. Please try again.'
            }
          };

          this.messages.update(msgs => [...msgs, errorMessage]);
          this.isLoading = false;
          this.sendingRequest = false;
          this.scrollToBottom();
        }
      );
  }

  // Will be removed once API for DCI (Legionella Dashboard) is unified in BED.
  private isLegionellaTestResultsRoute(): boolean {
    return this.router.url.includes('/legionella-test-results');
  }

  // Utility methods for template

  /**
   * Check if a message is from the user
   * @param message - Chat message to check
   * @returns True if message is from user
   */
  isUserMessage(message: ChatMessage): boolean {
    return message.type === 'user';
  }

  /**
   * Check if a message is from the bot
   * @param message - Chat message to check
   * @returns True if message is from bot
   */
  isBotMessage(message: ChatMessage): boolean {
    return message.type === 'bot';
  }

  /**
   * Track by function for ngFor optimization
   * @param index - Index in the messages array
   * @param message - Message object
   * @returns Unique message ID for tracking
   */
  trackByMessageId(index: number, message: ChatMessage): string {
    return message.id;
  }

  /**
   * Get suggestion chips for a specific message
   * Only returns suggestions for the welcome message
   * 
   * @param message - Chat message to check
   * @returns Array of suggestion strings or empty array
   */
  getEvaSuggestions(message: ChatMessage): string[] {
    return message.id === this.welcomeMessageId ? this.suggestions : [];
  }

  /**
   * Handle site/context point selection from search component
   * Updates the current context and reinitializes chat
   * 
   * @param $event - Event containing selected search result details
   */
  public getSelectedSiteData($event: any): void {
    this.selectedSearchDetails = $event?.selectedSearchedResult;
    this.contextPointId = $event?.selectedSearchedResult?.SiteId;
    this.searchResultModal = $event;
    this.initializeChat();
  }

  /**
   * Toggle voice recording on/off
   * Starts recording if not active, stops if active
   */
  toggleRecording(): void {
    if (this.isRecording) {
      this.stopRecording();
    } else {
      this.startRecording();
    }
  }

  /**
   * Trigger the hidden image file input
   */
  triggerImageUpload(): void {
    this.imageInput()?.nativeElement.click();
  }

  /**
   * Handle image file selection
   */
  onImageSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      console.log('Image selected:', file.name, file.type, file.size);
      // TODO: Implement image upload to backend
      // For now, display the filename in the input
      this.currentMessage = `[Image: ${file.name}]`;
    }
  }

  /**
   * Handle help button click
   */
  onHelpClick(): void {
    console.log('Help button clicked');
    // TODO: Implement help functionality (e.g., show help dialog, documentation, or tips)
  }

  /**
   * Clear the selected search/site context
   * Resets context-related state when user clears selection
   * 
   * @param $event - Boolean flag indicating if clear should be executed
   */
  public clearSelection($event: boolean): void {
    if ($event) {
      this.searchResultModal = null;
      this.contextPointId = null;
    }
  }

  /**
   * Handle suggestion chip selection
   * Fills the input field with the selected suggestion and sends the message
   * 
   * @param selectedChip - The chip item that was selected
   */
  onChipSelection(selectedChip: IAgentChipList) {
    this.currentMessage = selectedChip.value;
    this.sendMessage();
  }


  /**
   * Check microphone permission status
   * @private
   */
  private async checkMicrophonePermission(): Promise<void> {
    if ('navigator' in window && 'permissions' in navigator) {
      try {
        const permission = await navigator.permissions.query({ name: 'microphone' as PermissionName });
        this.microphonePermission = permission.state;

        // Listen for permission changes
        permission.addEventListener('change', () => {
          this.microphonePermission = permission.state;
        });

      } catch (error) {
      }
    }
  }

  /**
   * Request explicit microphone permission from the user
   * @returns Promise resolving to true if granted, false if denied
   * @private
   */
  private async requestMicrophonePermission(): Promise<boolean> {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      // Stop the stream immediately as we only wanted permission
      stream.getTracks().forEach(track => track.stop());
      this.microphonePermission = 'granted';
      return true;
    } catch (error) {
      this.microphonePermission = 'denied';
      this.showPermissionError();
      return false;
    }
  }

  /**
   * Initialize Web Speech API for voice recognition
   * Configures continuous listening mode with real-time transcription
   * @private
   */
  private setupVoiceRecognition(): void {
    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;

    if (SpeechRecognition) {
      this.voiceSupported = true;
      this.recognition = new SpeechRecognition();

      // Configure settings for continuous recording
      this.recognition.continuous = true;  // Keep listening continuously
      this.recognition.interimResults = true;  // Show real-time results
      this.recognition.lang = 'en-US';
      this.recognition.maxAlternatives = 1;  // Only need the best result

      // Event handlers - SET ONCE HERE
      this.recognition.onstart = () => {
        this.isRecording = true;
      };

      this.recognition.onresult = (event: any) => {
        let finalTranscript = '';
        let interimTranscript = '';

        // Process all results
        for (let i = event.resultIndex; i < event.results.length; i++) {
          const transcript = event.results[i][0].transcript;

          if (event.results[i].isFinal) {
            finalTranscript += transcript + ' ';
          } else {
            interimTranscript += transcript;
          }
        }

        // Update UI with current speech
        if (finalTranscript) {
          this.currentMessage = (this.currentMessage + finalTranscript).trim();
          this.sendMessage();
        }

        // Show interim results as placeholder only
        if (interimTranscript) {
          this.updatePlaceholderMessage(`Hearing: "${interimTranscript}"`);
        }
      };

      this.recognition.onend = () => {
        // If we're supposed to be recording (user still holding button), restart
        if (this.isRecording) {
          // Restart recognition after a brief pause
          setTimeout(() => {
            if (this.isRecording) {
              try {
                this.recognition.start();
              } catch (error) {
                this.handleSpeechError('restart-failed');
              }
            }
          }, 100);
        } else {
          // User stopped recording - reset to default placeholder
          this.updatePlaceholderMessage('Ask me anything..!');
        }
      };

      this.recognition.onerror = (event: any) => {
        this.isRecording = false;
        // Reset to default placeholder on error
        this.updatePlaceholderMessage('Ask me anything..!');
      };
    } else {
    }
  }

  /**
   * Start voice recording with permission checks
   * Initiates continuous speech recognition
   */
  async startRecording(): Promise<void> {
    if (!this.voiceSupported) {
      alert('Voice recognition not supported in this browser');
      return;
    }

    // If already recording, stop it
    if (this.isRecording) {
      this.recognition.stop();
      return;
    }

    // Check/request permission before starting
    if (this.microphonePermission === 'denied') {
      this.showPermissionError();
      return;
    }

    if (this.microphonePermission === 'prompt') {
      const granted = await this.requestMicrophonePermission();
      if (!granted) return;
    }

    try {
      // Clear previous message if starting fresh
      if (!this.currentMessage.trim()) {
        this.currentMessage = '';
      }

      // Start continuous recognition
      this.recognition.start();
    } catch (error) {
      this.handleSpeechError('start-failed');
    }
  }

  /**
   * Stop voice recording
   * Halts speech recognition and cleans up associated timeouts
   */
  stopRecording() {
    if (this.isRecording) {
      this.isRecording = false; // Set this BEFORE calling stop() so onend knows it was intentional

      // Clear any pending restart timeout
      if (this.recordingTimeout) {
        clearTimeout(this.recordingTimeout);
        this.recordingTimeout = null;
      }

      this.recognition.stop(); // This will trigger onend which resets placeholder
    }
  }

  /**
   * Handle speech recognition errors
   * Provides user-friendly error messages for various failure scenarios
   * 
   * @param error - Error code string
   * @private
   */
  private handleSpeechError(error: string): void {
    let message = '';

    switch (error) {
      case 'not-allowed':
        message = 'Microphone access denied. Please allow microphone permissions in your browser settings.';
        break;
      case 'no-speech':
        message = 'No speech detected. Please speak clearly and try again.';
        break;
      case 'network':
        message = 'Network error occurred. Please check your internet connection.';
        break;
      case 'audio-capture':
        message = 'No microphone found. Please check your audio devices.';
        break;
      case 'start-failed':
        message = 'Failed to start voice recognition. Please try again.';
        break;
      case 'restart-failed':
        message = 'Voice recognition stopped unexpectedly. Please click the microphone again.';
        break;
      default:
        message = 'Voice recognition failed. Please try again.';
    }

    // Show error message to user
    this.addSystemMessage(message, 'error');
  }

  /**
   * Display microphone permission error with instructions
   * @private
   */
  private showPermissionError(): void {
    const message = `
            🎤 Microphone access is required for voice input.
            
            To enable:
            1. Click the microphone icon in your browser's address bar
            2. Select "Always allow" for this site
            3. Try the voice button again
        `;

    this.addSystemMessage(message, 'error');
  }

  /**
   * Update the placeholder message and trigger change detection
   * 
   * @param message - New placeholder text
   * @private
   */
  private updatePlaceholderMessage(message: string): void {
    this.placeHolderMessage = message;
    this.cdr.detectChanges();
  }

  /**
   * Add a system message to the chat (info or error)
   * 
   * @param text - Message content
   * @param type - Message type ('info' or 'error')
   * @private
   */
  private addSystemMessage(text: string, type: 'info' | 'error' = 'info'): void {
    const systemMessage: ChatMessage = {
      id: this.generateId(),
      type: 'bot',
      timestamp: new Date(),
      content: {
        type: 'text',
        data: `${type === 'error' ? '⚠️' : 'ℹ️'} ${text}`
      }
    };
    this.messages.update(msgs => [...msgs, systemMessage]);
    this.scrollToBottom();
  }

  /**
   * Start a new chat session
   * Clears current conversation and shows welcome message with suggestions
   */
  startNewChat() {
    this.currentMessage = '';
    this.initializeChat();
  }

  /**
   * Submit feedback for a bot message
   * 
   * @param messageId - ID of the message being rated
   * @param didUserLike - True if user liked, false if disliked
   */
  sendFeedback(messageId: string, didUserLike: boolean) {
    this.feedBackSelected = { messageId: messageId, didUserLike: didUserLike, feedBack: '' };
  }

  /**
   * Toggle AI agent flyout visibility
   */
  openAIAgent() {
    this.showAIAgent = !this.showAIAgent;
  }

  /**
   * Save the edited message and resend to get new response
   * Removes both the user message and subsequent bot response before resending
   */
  saveEditedMessage(): void {
    if (!this.editMessageId || !this.editingMessage.trim()) {
      return;
    }

    // Find the index of the message being edited
    const currentMessages = this.messages();
    const messageIndex = currentMessages.findIndex(msg => msg.id === this.editMessageId);
    if (messageIndex === -1) {
      return;
    }

    // Remove the user message and the next bot message (if it exists)
    const messagesToRemove = 1; // Remove the user message
    let removeCount = messagesToRemove;

    // Check if there's a bot message immediately after this user message
    if (messageIndex + 1 < currentMessages.length &&
      currentMessages[messageIndex + 1].type === 'bot') {
      removeCount = 2; // Remove both user and bot message
    }

    // Remove the messages by creating a new array without them
    const newMessages = [...currentMessages];
    newMessages.splice(messageIndex, removeCount);
    this.messages.set(newMessages);

    // Create new user message with edited content
    // const newUserMessage: ChatMessage = {
    //   id: this.editMessageId,
    //   type: 'user',
    //   timestamp: new Date(),
    //   content: {
    //     type: 'text',
    //     data: this.editingMessage.trim()
    //   }
    // };

    // Insert the new message at the same position
    // this.messages.splice(messageIndex, 0, newUserMessage);



    // Send the new message to get a fresh response
    this.currentMessage = this.editingMessage.trim();
    this.sendMessage(this.editMessageId);

    // Reset edit state
    this.cancelEdit();
  }

  /**
   * Cancel message edit mode without saving changes
   */
  cancelEdit(): void {
    this.editMessageId = null;
    this.editingMessage = '';
  }

  /**
   * Handle chat history selection from flyout
   * Sets the chat ID to continue an existing conversation
   * 
   * @param historyItem - Selected chat history item
   */
  onChatHistorySelected(historyItem: any): void {
    // Set the chatID to continue the existing conversation
    this.chatID = historyItem?.id;
    this.isLoadingChat = true;
    this.enableChatStreaming = false;

    this.getContexPointDetails(historyItem?.ContextIdentifier?.Value);

    // Chat history service method is unavailable in AIAgentService.
    // Intentionally skip loading old history and keep current flow as no-op.
    this.isLoadingChat = false;
  }

  /**
   * Close the AI agent flyout panel
   * 
   * @param showAIAgent - New visibility state
   */
  public closeAgentFlyout(showAIAgent: boolean): void {
    if (this.showAIAgent) {
      this.aiAgentService.setEvaState({ show: false });
    }
    this.showAIAgent = showAIAgent;

  }

  /**
   * Get context point (site) details
   * Retrieves or uses cached site information for the conversation context
   * 
   * @param contextPointID - ID of the context point to load
   */
  getContexPointDetails(contextPointID: string) {
    // Check if we already have this context point cached
    if (this.contextPointCache[contextPointID]) {

      // Use cached data
      setTimeout(() => {
        this.searchInputData.SearchTabs[1].activeData = {
          contextPointId: this.contextPointCache[contextPointID].contextPointId,
          contextPointName: this.contextPointCache[contextPointID].siteName,
          selectionHierarchy: [],
        };
        this.selectedSearchDetails.Site = this.contextPointCache[contextPointID].siteName;
        this.contextPointId = this.contextPointCache[contextPointID].contextPointId;
      }, 0);

      return; // Exit early, no API call needed
    }

    // Site lookup service method is unavailable in AIAgentService.
    // Intentionally skip enrichment and keep only the bare context point id.
    this.contextPointId = Number(contextPointID);
    this.isLoadingChat = false;
  }

  /**
   * Clear the context point cache
   * Called during component cleanup
   */
  clearContextPointCache(): void {
    this.contextPointCache = {};
  }

  /**
   * Handle right panel toggle event
   * Loads chat history when the right panel is opened
   * 
   * @param showRightPanel - True if right panel is now visible
   */
  onToggleRightPanel(showRightPanel: boolean) {
    if (showRightPanel) {
      this.chatHistoryList()?.getChatHistoryList();
    }
  }

}

